import React from 'react'
import ReactDOM from "react-dom"
import NavigationMenu_TopHeader from "../../components/top-header/top-header"
import NavigationSection from "../../../../core/model2/navigation/navigation-section"
import {NavigationSectionType} from "../../../../core/model2/navigation/@const"
import {MenuComponentProps} from "../const";
import VScroll from "../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll";
import NavigationMenuSection from "../../menu-items/section/section";
import NavigationMenuItemUrl from "../../menu-items/menu-item-url";
import {UPGRADE_PRO} from "../../../../core/gd/const/license";
import NavigationMenu_ProjectsTags from "../projects/tags/tags"
import {BUS_TREE_CHANGE} from "../../../../core/gd/bus/bus-event-type"

// const debug = "MainMenu_Tools"
const debug = false

export default class MainMenu_Tools extends React.Component<MenuComponentProps> {

    private animationDelay  : any
    private animShow        : boolean = false

    public navigationSection : NavigationSection    = gd.layout.navigation.navigationStructure.get(NavigationSectionType.TOOLS)

    constructor(props:MenuComponentProps) {
        super(props);
    }

    componentDidMount() {
        //needed for animation
        this.animationDelay = _.delay(()=>{
            this.animShow = true
            const dom = ReactDOM.findDOMNode(this);
            gd.utils.Dom.addClass(dom, 'anim-show');
        }, 50);

        gd.bus.subscribe(BUS_TREE_CHANGE, this, this.onTreeChange)
    }

    componentWillUnmount() {
        clearTimeout(this.animationDelay)

        gd.bus.unsubscribe(this)
    }

    onTreeChange = () => {
        debug && console.log(debug, 'onTreeChange')

        this.forceUpdate()
    }

    render() {
        const classes = Classes('main-menu-container menu-tools ui5-menu hovered',{
            'animation': gd.layout.shouldAnimateMenu && !this.props.noAnimation,
            'anim-show': this.animShow
        });

        // const showCrmMenu = gd.modules.crm.enabled;

        const isManager = gd.user.isManager();
        const rootTags = gd.session.projects.rootTags

        const showForms = isManager && (gd.modules.requests.enabled || gd.modules.publicForms.enabled)
        const showTags = rootTags?.length > 0

        return (
            <div className={classes}>

                <NavigationMenu_TopHeader space={gd.spaces.tools} />

                <VScroll ref={this.props.refScroll} className="main-menu-scroll" mutationObserverEnabled={true}>


                    <NavigationMenuSection collapsible={false} systemName="tools-automations" name="Automations" >
                        {isManager &&
                            <NavigationMenuItemUrl name="Automations" icon="i5-automation" url={'o/automations'}
                                                   upgradeRequired={!gd.company.license.isPro ? UPGRADE_PRO : false }
                                                   navigationSection={gd.spaces.tools.navigation}
                            />
                        }

                        {isManager &&
                            <NavigationMenuItemUrl name="Recurring Items" icon="i5-recurrence" url={'o/recurrences'} navigationSection={gd.spaces.tools.navigation} />
                        }

                        {isManager &&
                            <NavigationMenuItemUrl name="Validations" icon="i5-emergency" url={'o/validations'} navigationSection={gd.spaces.tools.navigation} />
                        }

                    </NavigationMenuSection>

                    {showForms &&
                        <NavigationMenuSection collapsible={false} systemName="tools-forms" name="Forms" >

                            {gd.modules.publicForms.enabled &&
                                <NavigationMenuItemUrl className="item" name="Forms" icon="i5-form" url="o/forms" navigationSection={gd.spaces.tools.navigation}/>
                            }

                            {gd.modules.requests.enabled &&
                                <NavigationMenuItemUrl className="item" name="Requests" icon="i5-request" url="o/requests" navigationSection={gd.spaces.tools.navigation}/>
                            }

                        </NavigationMenuSection>
                    }

                    <NavigationMenuSection collapsible={false} systemName="tools-import-export" name="Import/Export" >
                        <NavigationMenuItemUrl className="item" name="Import" icon="i5-import-from" url="o/import" navigationSection={gd.spaces.tools.navigation}/>
                        <NavigationMenuItemUrl className="item" name="Export" icon="i5-export-to" url="o/export" navigationSection={gd.spaces.tools.navigation}/>

                    </NavigationMenuSection>

                    {showTags &&
                        <NavigationMenu_ProjectsTags showAdd = {true}
                                                     tags    = {rootTags}/>}

                    <NavigationMenuSection name="Misc" collapsible={false} systemName="companyTools">
                        <NavigationMenuItemUrl name="Big Screens" icon="i5-tv" url={'o/big-screen'} navigationSection={gd.spaces.tools.navigation}/>
                    </NavigationMenuSection>


                    <NavigationMenuSection name="Archived & Deleted" collapsible={false} systemName="companyTools">


                        <NavigationMenuItemUrl name="Archived Projects" icon="i5-someday" url={'o/archived-projects'} navigationSection={gd.spaces.tools.navigation}/>
                        <NavigationMenuItemUrl name="Trash" icon="i5-trash-alt" url={'o/trash'} navigationSection={gd.spaces.tools.navigation} />

                    </NavigationMenuSection>



                </VScroll>

            </div>
        );
    }
}
